import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services';
import {  DickerSelectListItem } from '../../../models/check-out.model';
import { Subject } from 'rxjs';
import { ApiResponse } from '../../../models/api-response.model';
import { finalize, takeUntil } from 'rxjs/operators';
import { AdobeService } from '../../../services/adobe.service';
import { IAMPAssociationResponse, IAMPAssociationResponseLineItem, IAMPResellerAssociationRequest } from '../../../models/amp.model';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { AMPAssociateFinishComponent } from '../../../popup-collection/amp-associate-finish/amp-associate-finish.component';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-associate-adobe-customer',
  templateUrl: './associate-adobe-customer.component.html',
  styleUrls: ['./associate-adobe-customer.component.css']
})
export class AssociateAdobeCustomerComponent implements OnInit {

  title: string = "Change Reseller";
  public resellerId: string;
  public showNoPreviewResult = false;
  userFormGroup: FormGroup;
  loadContent: boolean = false;
  programType: string;
  tenantId: string = '';
  companyCode: string = '';
  selectedPayment: string = '';
  paymentList: DickerSelectListItem[] = [];
  preivewLoading = false;
  disableRequest = false;
  public displayedColumns: string[] = [
    'subscriptionId',
    'offerId',
    'offerName',
    'renewalDate',
    'quantity'
  ];
  user_validation_messages: any = {
    "approvalCode": [
      { class: "approvalCodeValidate", message: "Please enter valid approval code" }
    ],
    "resellerId": [
      { class: "resellerIdValidate", message: "Please enter reseller ID" }
    ],
    "requestedBy": [
      { class: "requestedByValidate", message: "Please enter email address" }
    ]
  };
  previewResult: IAMPAssociationResponseLineItem[]
  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private adobeService: AdobeService,
    private dialog: MatDialog,
    public authService: AuthService
  ) {
    this.userFormGroup = this.formBuilder.group({
      approvalCode: new FormControl("", Validators.compose([Validators.required])),
      // resellerId: new FormControl("", Validators.compose([Validators.required])),
      requestedBy: new FormControl("", Validators.compose([Validators.required, this.commonService.emailValidatorRegex()]))
    });
  }

  ngOnInit() {
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
    this.loadContent = false;
    this.companyCode = this.commonService.readCookie("CompanyCode");
    this.adobeService.getCurrentAMPResellerId.pipe(takeUntil(this.ngUnsubscribe)).subscribe(resellerId => {
      this.resellerId = resellerId;
    });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  public previewAssociation(): void {
    if (
      this.userFormGroup.get('approvalCode').valid &&
      // this.userFormGroup.get('resellerId').valid &&
      this.userFormGroup.get('requestedBy').valid
    ) {

      const request = {
        type: 'RESELLER_CHANGE',
        action: 'PREVIEW',
        approvalCode: this.userFormGroup.get('approvalCode').value,
        resellerId: this.resellerId,
        requestedBy: this.userFormGroup.get('requestedBy').value
      } as IAMPResellerAssociationRequest;

      this.preivewLoading = true;
      this.adobeService
        .AMPAssociateReseller(request)
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(finalize(() => this.preivewLoading = false))
        .subscribe(
          (response: IAMPAssociationResponse | ApiResponse) => {
            if ('responseMessage' in response && !(response as ApiResponse)?.status ) {
              this.commonService.implementToast(response.responseMessage, 'Error');
            } else {
              let validResponse = response as IAMPAssociationResponse;
              if (validResponse?.lineItems?.length) {
                this.previewResult = validResponse?.lineItems;
              } else {
                this.showNoPreviewResult = true;
              }
            }
          },
          (error: any) => {
            console.error(error);
            this.commonService.implementToast(error, "Error");
          }
        );
    } else {
      this.isNotValidField("approvalCode", this.user_validation_messages.approvalCode);
      // this.isNotValidField("resellerId", this.user_validation_messages.resellerId);
      this.isNotValidField("requestedBy", this.user_validation_messages.requestedBy);
    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path == "requestedBy") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  public commitAssociation(): void {
    const request = {
      type: 'RESELLER_CHANGE',
      action: 'COMMIT',
      approvalCode: this.userFormGroup.get('approvalCode').value,
      resellerId: this.resellerId,
      requestedBy: this.userFormGroup.get('requestedBy').value
    } as IAMPResellerAssociationRequest;

    this.preivewLoading = true;
    this.disableRequest = true;
    this.adobeService
      .AMPAssociateReseller(request)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response: IAMPAssociationResponse | ApiResponse) => {
          if ('responseMessage' in response && !(response as ApiResponse)?.status ) {
            this.commonService.implementToast(response.responseMessage, 'Error');
          } else {
            let validResponse = response as IAMPAssociationResponse;
            if (validResponse?.customerId) {
              this.dialog.open(AMPAssociateFinishComponent, {
                width: '500px',
                data: validResponse
              })
              .afterClosed().subscribe(nav => {
                if (nav) {
                  this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP/AMPDetails/' + validResponse.customerId);
                }
              })
            }
          }
        },
        (error: any) => {
          console.error(error);
          this.commonService.implementToast(error, "Error");
        },
        () => {
          this.preivewLoading = false;
          this.disableRequest = false;
        }
      );
  }
  
  myTabSelectedTabChange(event: MatTabChangeEvent) {
    const tabName = event.tab.textLabel;
    this.previewResult = [];
    if (tabName == 'In-Progress' || tabName == 'Completed') {
      this.preivewLoading = true;
      this.adobeService.getAMPCustomerAssociations(tabName).subscribe((res: IAMPAssociationResponse[]) => {
        this.previewResult = [ ...res ]
        this.preivewLoading = false;
      },
        (error: any) => {
          console.error(error);
          this.preivewLoading = false;
          this.disableRequest = false;
        });
    }
    
  }

  public resetPage() {
    this.previewResult = [];
    this.userFormGroup.get('approvalCode').setValue('');
    this.userFormGroup.get('requestedBy').setValue('');
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP');
  }
}
